import { Box as MuiBox } from "@mui/material";
import { Theme } from "common";
import { useOIS } from "app/services/OISService/OISProvider";
import OISContainer from "./OISContainer";

const boxStyles = {
  marginTop: "1em",
  paddingX: "1.5em",
  backgroundColor: Theme.palette.primary.contrastText,
  boxShadow: "rgba(0, 0, 0, 0.1) 1px 1px 3px 0.2px",
};

const OISPage = (props) => {
  const {
    searchFilters: { action },
  } = useOIS();

  return (
    <MuiBox sx={{ paddingX: "1.5em" }}>
      <MuiBox
        id="ois-home"
        sx={{ ...boxStyles, width: action ? "auto" : "1625px" }}
      >
        <OISContainer />
      </MuiBox>
    </MuiBox>
  );
};

export default OISPage;
